// ビルド時 or ランタイムに埋め込む環境設定。
// CDK デプロイ後、Vite ビルドに以下の VITE_* env を差し込んでください。
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000',
  cognito: {
    authority: import.meta.env.VITE_COGNITO_AUTHORITY ?? '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
    redirectUri:
      import.meta.env.VITE_COGNITO_REDIRECT_URI ??
      `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri:
      import.meta.env.VITE_COGNITO_LOGOUT_URI ?? window.location.origin,
    scope: 'openid email profile',
  },
} as const;
